import React from 'react';
import { CalendarDays, ClipboardCheck, Crown, Search, Shapes, Stethoscope } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ProcessSection = () => {
  const { t } = useTranslation('prosthetics');
  const steps = [
    {
      icon: <Stethoscope className="h-10 w-10 text-dental" />,
      title: t('process.steps.0.title'),
      description: t('process.steps.0.description'),
    },
    {
      icon: <Search className="h-10 w-10 text-dental-coral" />,
      title: t('process.steps.1.title'),
      description: t('process.steps.1.description'),
    },
    {
      icon: <ClipboardCheck className="h-10 w-10 text-dental-mint" />,
      title: t('process.steps.2.title'),
      description: t('process.steps.2.description'),
    },
    {
      icon: <Shapes className="h-10 w-10 text-dental-purple" />,
      title: t('process.steps.3.title'),
      description: t('process.steps.3.description'),
    },
    {
      icon: <Crown className="h-10 w-10 text-dental-gold" />,
      title: t('process.steps.4.title'),
      description: t('process.steps.4.description'),
    },
    {
      icon: <CalendarDays className="h-10 w-10 text-dental-tertiary" />,
      title: t('process.steps.5.title'),
      description: t('process.steps.5.description'),
    }
  ];

  return (
    <section id="process" className="py-16 lg:py-20 bg-dental-light/20 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-20 right-0 w-80 h-80 bg-dental/10 rounded-full blur-3xl -z-10"></div>
      <div className="absolute bottom-20 left-0 w-60 h-60 bg-dental-coral/10 rounded-full blur-3xl -z-10"></div>
      
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-display font-bold mb-4 text-gradient-primary inline-block relative reveal" data-direction="up">
            {t('process.heading')}
          </h2>
          <p className="text-xl text-dental-dark/80 max-w-3xl mx-auto reveal" data-direction="up">
            {t('process.intro')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow relative reveal" 
              data-direction="up" 
              data-delay={0.1 * index}
            >
              <div className="mb-6">
                {step.icon}
              </div>
              <h3 className="text-xl font-display font-bold mb-4 text-dental-dark">{step.title}</h3>
              <p className="text-dental-dark/70">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
